/**
 * Eric Carle custom JavaScript
 *
 * Wires up:
 *   - Click-to-open mega menu (per EC-STORE-016, no hover behavior)
 *   - Outside-click + Escape close
 *   - aria-expanded sync for accessibility
 *   - Footer current-year fill ([data-carle-current-year])
 *
 * Loaded via snippets/custom.globals.liquid. Keep this file lean — prefer
 * theme app extensions in the Gadget app for anything that touches member
 * data, RE NXT lookups, or POS surfaces.
 */
(function () {
  'use strict';

  function setExpanded(li, expanded) {
    li.setAttribute('aria-expanded', expanded ? 'true' : 'false');
    const trigger = li.querySelector(':scope > [data-carle-mega-trigger]');
    if (trigger) trigger.setAttribute('aria-expanded', expanded ? 'true' : 'false');
  }

  function closeAll(scope) {
    const open = scope.querySelectorAll('[data-carle-mega-parent][aria-expanded="true"]');
    open.forEach((li) => setExpanded(li, false));
  }

  function initMegaMenu(root) {
    const triggers = root.querySelectorAll('[data-carle-mega-trigger]');
    if (!triggers.length) return;

    triggers.forEach((trigger) => {
      const li = trigger.closest('[data-carle-mega-parent]');
      if (!li) return;
      trigger.setAttribute('aria-haspopup', 'true');
      trigger.setAttribute('aria-expanded', 'false');
      li.setAttribute('aria-expanded', 'false');

      trigger.addEventListener('click', (event) => {
        event.preventDefault();
        const wasOpen = li.getAttribute('aria-expanded') === 'true';
        closeAll(root);
        if (!wasOpen) setExpanded(li, true);
      });

      trigger.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') {
          setExpanded(li, false);
          trigger.focus();
        }
      });
    });

    // Outside click closes any open mega menu.
    document.addEventListener('click', (event) => {
      const target = event.target;
      if (!(target instanceof Node)) return;
      if (root.contains(target)) return;
      closeAll(root);
    });

    // Escape on the document closes any open mega menu.
    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') closeAll(root);
    });
  }

  function fillCurrentYear() {
    const targets = document.querySelectorAll('[data-carle-current-year]');
    if (!targets.length) return;
    const year = String(new Date().getFullYear());
    targets.forEach((el) => {
      el.textContent = year;
    });
  }

  function ready(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn, { once: true });
    } else {
      fn();
    }
  }

  ready(() => {
    document.querySelectorAll('[data-carle-mega-root]').forEach(initMegaMenu);
    fillCurrentYear();
  });
})();
